// src/integrations/GrowthBook/GrowthBook.js
import { GrowthBook } from "@growthbook/growthbook"
import { autoAttributesPlugin } from "@growthbook/growthbook/plugins"

const plugins = []

// Add plugins only in the browser
if (typeof window !== "undefined") {
  plugins.push(autoAttributesPlugin())
}

const growthbook = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: process.env.GATSBY_GROWTHBOOK_SDK_KEY,
  enableDevMode: true,
  plugins,
  enabled: !!process.env.GATSBY_GROWTHBOOK_SDK_KEY,
  // Attributs par défaut - peuvent être enrichis plus tard
  attributes: {
    id: null, // sera défini plus tard
    url: typeof window !== "undefined" ? window.location.href : "",
    path: typeof window !== "undefined" ? window.location.pathname : "",
    deviceType:
      typeof window !== "undefined"
        ? window.innerWidth < 768
          ? "mobile"
          : "desktop"
        : "unknown"
  }
  // Pas de trackingCallback ici : tant qu'il n'y en a aucun, le SDK empile les
  // expositions au lieu de les perdre. startExperimentTracking (experimentTracking.js)
  // le pose une fois Segment charge, ce qui vide la pile.
})

export default growthbook
